import { render, staticRenderFns } from "./index.vue?vue&type=template&id=321f5f78"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321f5f78')) {
      api.createRecord('321f5f78', component.options)
    } else {
      api.reload('321f5f78', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=321f5f78", function () {
      api.rerender('321f5f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/SvgIcon/index.vue"
export default component.exports